<template>
    <div class="housekeeper__content">
        <NavSecond :banner="icon_stra"></NavSecond>
        <div class="superstars_type animate__animated animate__fadeIn"><span>3+1管家式服务管理模式</span></div>
        <div>
            <div class="housekeeper animate__animated animate__fadeIn">
               <div class="over wrapper__w" :style="{'background':'url('+icon_gj02+')', 'background-size': '100% 100%', 'background-repeat': 'no-repeat'}">
                   <div class="fl box__align" style="width: 40%">
                       <div>经过多年发展，隐上创业团队与多位境内外设计大师结下了深厚的合作友谊，积累了国内外众多一线装修家居材料生产商资源，并引进国际先进的施工工艺，实行专业的“3+1”管家式服务。</div>
                   </div>
                   <div class="fr box__align">
                       <div>三个核心优势：“专属设计+匠心品控+管家服务”一个检验标准——一切以交付后客户满意度为最终标准</div>
                   </div>
               </div>
            </div>
            <div class="housekeeper__good--ul">
                <el-row :gutter="30" >
                    <el-col :span="8"  v-for="(item, index) in goodList" :key="index" >
                        <div class="housekeeper__good--item housekeeper__good--des  wow animate__fadeInUp" :style="{'background':'url('+item.img+')', 'background-size': 'cover', 'background-repeat': 'no-repeat'}">
                            <div class="bd">{{item.tit}}</div>
                            <div class="base">
                                <div class="title"><span>{{item.name}}</span></div>
                                <div class="des" v-html="item.des"></div>
                            </div>
                            <div class="code">{{item.code}}</div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div class="wrapper__wpd relative" style="padding-bottom: 75px;">
                <div class="over housekeeper__text housekeeper__good--des ">
                    <div class="fl ">
                        <div class="base  wow animate__fadeInUp">
                            <div class="title"><span>我们更专业</span></div>
                            <div class="des">
                                凭借领先的“3+1管家式服务”模式，精湛的施工工艺，隐上装饰已在高端装饰领域树立了诸多标杆性项目，并广受业界赞誉。
                                自成立以来，隐上装饰先后承接了诸如西溪湿地太极禅苑、西溪湿地坤宝会所、西溪湿地福堤、西溪湿地坤宝D会所（金麒麟）、西溪湿地上善养生会所、绿城桃花源、九溪玫瑰园、云栖玫瑰园、西湖高尔夫、大华西溪风情中心岛别墅、富春山居别墅、坤和西溪里、下沙保利东湾鹭沙郡府别墅、青山湖云上/云起/云水会所、桂花城别墅、郑州雁鸣湖玫瑰园、上海佘山天境别墅、上海铂锐滨江别墅、青岛海信依云别墅、绿城伍重苑、中大吴庄、湘湖壹号翠湖苑、桐庐颐居养生小镇、绿城桃源里、溪上玫瑰园、上海青溪花园、上海佘山东紫园、绿城卓越傲旋城售展中心及样板房、横店南江悦售展中心、横店专家楼会所A/B栋、湘湖生物细胞展厅、半木之家北京/上海/无锡经典展厅、西溪云庐别墅等众多高端私人会所与私宅工程，深获长三角地区财智阶层的青睐与信任。
                            </div>
                        </div>
                        <div class="base__img--int  wow animate__fadeInUp"><img :src="icon_gj04"></div>
                    </div>
                    <div class="int__right fr  wow animate__fadeInUp">
                        <img :src="icon_gj03">
                    </div>
                </div>
                <div class="bk"></div>
            </div>

        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import test1 from '@/assets/img/test1.jpg'
    import test2 from '@/assets/img/test2.jpg'
    import icon_stra from '@/assets/img/gj01.png'
    import icon_cos02 from '@/assets/img/cos02.png'
    import icon_cos03 from '@/assets/img/cos03.png'
    import icon_cos04 from '@/assets/img/cos04.png'
    import icon_gj02 from '@/assets/img/gj02.jpg'
    import icon_gj03 from '@/assets/img/gj03.png'
    import icon_gj04 from '@/assets/img/gj04.jpg'

    import NavSecond from '@/components/NavSecond'
    import Footer from '@/layouts/Footer'


    export default {
        name: 'Test',
        data (){
            return {
                icon_stra,test1,test2, icon_cos02, icon_cos03, icon_cos04, icon_gj02, icon_gj03, icon_gj04,
                goodList: [
                    {
                        tit: '好设计',
                        name: '专属设计 私享尊贵',
                        des: '私人定制：他们是业内的资深设计大师。\n' +
                            '专属设计:“一对一”服务，提供最合适的整体解决方案。',
                        img: icon_cos02,
                        code: '01'
                    },
                    {
                        tit: '好工艺',
                        name: '匠心品控 国际标准',
                        des: '匠人匠心：持证上岗，师徒制定期培训；技艺精湛，严格品质管控。\n' +
                            '“德系标准”：德国智能保障体系，质量坚如磐石。\n' +
                            '                            ',
                        img: icon_cos03,
                        code: '02'
                    },
                    {
                        tit: '好服务',
                        name: '“管家”服务 全程关怀',
                        des: '“管家”服务 全程“管家式服务”护航，保障高品质服务。明码标价：服务收费制，明明白白消费，满足个性尊贵需求。',
                        img: icon_cos04,
                        code: '03'
                    }
                ]
            }
        },
        components: {
            NavSecond,Footer
        },
        mounted() {
            this.$wow.init()
        },
    }
</script>
<style  lang="scss" scoped>
    .housekeeper__content{
        .bk{
            height: 273px;
            background: #f1f1f1;
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
        }
        .superstars_type{
            text-align: center;
            font-size: 36px;
            font-weight: bold;
            color: #010101;
            height: 200px;
            line-height: 250px;
            span{
                position: relative;
                &::after{
                    content: '';
                    display: block;
                    position: absolute;
                    left: 50%;
                    margin-left: -16px;
                    bottom: -20px;
                    width: 32px;
                    height: 4px;
                    background: #F55E1B;
                }
            }
        }
        .housekeeper{
            height: 250px;
            margin-bottom: 240px;
            & > div{
                height: 100%;
            }
            /*& > div{*/
            /*    width: 50%;*/
            /*    height: 100%;*/
            /*    & > div{*/
            /*        margin: 0 6%;*/
            /*    }*/
            /*}*/
            .fl{
                height: 100%;
                width: 50%;
                font-size: 16px;
                font-weight: 400;
                color: #000000;
                line-height: 24px;
                & > div{
                    margin-left: 10%;
                }
            }
            .fr{
                height: 100%;
                width: 50%;
                font-size: 24px;
                font-weight: 400;
                font-style: italic;
                color: #FFFFFF;
                line-height: 30px;
                & > div{
                    margin-right: 10%;
                }
            }
        }
        .housekeeper__good--des{
            .title {

                margin: 40px 0;
                font-size: 22px;
                font-weight: 400;
                color: #000000;
                span {
                    position: relative;

                    &::after {
                        content: '';
                        display: block;
                        position: absolute;
                        left: 0;
                        bottom: -10px;
                        width: 32px;
                        height: 4px;
                        background: #F55E1B;
                    }
                }

            }

            .base{
                margin: 0 15%;
            }
            .des{
                font-size: 16px;
                font-weight: 400;
                color: #010101;
                line-height: 24px;
                margin-top: 40px;
                p{
                    margin-top: 20px;
                }
            }
        }
        .housekeeper__good--item{
            height: 343px;
            position: relative;
            .bd{
                font-size: 28px;
                font-weight: bold;
                color: #000000;
                line-height: 24px;
                margin: 0 15%;
                padding-top: 40px;
            }
            .title{
                margin-top: 15px;
            }
            .code{
                position: absolute;
                right: 10px;
                bottom: 0;
                color: rgba(0,0,0,0);
                -webkit-text-stroke: 1px #F25416;
                text-stroke: 1px #fff;
                font-family: "avant-bold";
                line-height: 92px;
                text-align: left;
                font-size: 80px;
                font-weight: bold;
                font-family: Microsoft YaHei;
            }
        }
        .housekeeper__good--ul{
            margin-left: 10%;
            padding-right: 10%;
            background: #F1F1F1;
            & > div{
                position: relative;
                top: -125px;
            }
        }
        .housekeeper__text{
            padding-top: 120px;
            position: relative;
            z-index: 22;
            & > div{
                width: 50%;
            }
            .base__img--int{
                margin-top: 50px;
                position: relative;
                top: 50px;
                img{
                    width: 92%;
                    display: block;
                }
            }
            .base{
                margin: 0 15%;
            }
            .des{
                font-size: 16px;
                font-weight: 400;
                color: #010101;
                line-height: 24px;
                margin-top: 40px;
                p{
                    margin-top: 20px;
                }
            }
            .int__right{
                img{
                    display: block;
                    width: 90%;
                    float: right;
                }
            }
            .title{
                font-size: 32px;
                font-weight: bold;
                color: #010101;
            }
        }

    }

</style>
